export default __webpack_public_path__ + "static/media/justinphoto.92fdda53.jpg";